export const MODEL_FIELDS = {
  firstName: 'firstName',
  lastName: 'lastName',
  oldIban: 'oldIban',
  newIban: 'newIban',
  additionalAccountOwners: 'additionalAccountOwners',
  replyFaxNumberExpandable: 'replyFaxNumberExpandable',
  replyFaxNumber: 'replyFaxNumber',
  moveDeposits: 'moveDeposits',
  moveDebits: 'moveDebits',
  moveStandingOrders: 'moveStandingOrders',
  closeAccount: 'closeAccount',
  transferSaldo: 'transferSaldo',
  accountCloseDeadline: 'accountCloseDeadline',
  dispatchAddressPostcode: 'dispatchAddress_postcode',
  dispatchAddressCity: 'dispatchAddress_city',
  dispatchAddressCountry: 'dispatchAddress_Country',
  dispatchAddressAddress: 'dispatchAddress_address',
  dispatchAddress: 'dispatchAddress',
};
